import { Assets } from "lib/at-data/assets/assets";

export type AssetsContext = {
  assets: Assets;
};

export const AssetsContext = (assets: Assets) => ({ assets });
